import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismiss: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionGeneric: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	additionalInfoGeneric: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionGenericGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'invite-prompt-on-link-insert.invite-success-flag.title',
		defaultMessage:
			'{inviteeCount, plural, one {Invite successfully sent} other {Invites successfully sent}}',
		description: 'Title of success flag shown when invites are sent successfully',
	},
	dismiss: {
		id: 'invite-prompt-on-link-insert.invite-success-flag.dismiss',
		defaultMessage: 'Ok, got it',
		description: 'Button to dismiss the flag',
	},
	descriptionGeneric: {
		id: 'invite-prompt-on-link-insert.invite-success-flag.description-generic',
		defaultMessage:
			'{inviteeCount, plural, one {<strong># project assignee</strong> will get an email inviting them to <strong>{productDisplayName}</strong>.} other {<strong># project assignees</strong> will get an email inviting them to <strong>{productDisplayName}</strong>.}}',
		description: 'Description informing the user how many invites were successfully sent',
	},
	additionalInfoGeneric: {
		id: 'invite-prompt-on-link-insert.invite-success-flag.additional-info-generic',
		defaultMessage:
			'Admin may need to approve some assignees before they can join <strong>{productDisplayName}</strong>.',
		description: 'Description explaining that some invitees will still require admin approval',
	},
	descriptionGenericGalaxia: {
		id: 'invite-prompt-on-link-insert.invite-success-flag.description-generic-galaxia',
		defaultMessage:
			'{inviteeCount, plural, one {<strong># space assignee</strong> will get an email inviting them to <strong>{productDisplayName}</strong>.} other {<strong># space assignees</strong> will get an email inviting them to <strong>{productDisplayName}</strong>.}}',
		description: 'Description informing the user how many invites were successfully sent',
	},
});
